var _rect, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBanks = function SvgBanks(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FDEDE7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2918 10.2117C15.7098 9.89168 16.2908 9.89168 16.7088 10.2117L21.6708 14.0047C22.3028 14.4877 21.9638 15.4957 21.1698 15.4997H10.8298C10.0368 15.4957 9.69684 14.4877 10.3298 14.0047L15.2918 10.2117ZM15.9998 13.7497C16.1988 13.7497 16.3895 13.6707 16.5302 13.53C16.6708 13.3894 16.7498 13.1986 16.7498 12.9997C16.7498 12.8008 16.6708 12.61 16.5302 12.4693C16.3895 12.3287 16.1988 12.2497 15.9998 12.2497C15.8009 12.2497 15.6102 12.3287 15.4695 12.4693C15.3289 12.61 15.2498 12.8008 15.2498 12.9997C15.2498 13.1986 15.3289 13.3894 15.4695 13.53C15.6102 13.6707 15.8009 13.7497 15.9998 13.7497Z",
    fill: "#EE6F44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 16.5V19.5H13V16.5H11.5Z",
    fill: "#EE6F44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16.5V19.5H15.5V16.5H14Z",
    fill: "#EE6F44"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16.5V19.5H18V16.5H16.5Z",
    fill: "#EE6F44"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 16.5V19.5H20.5V16.5H19Z",
    fill: "#EE6F44"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 21.75C10 21.06 10.56 20.5 11.25 20.5H20.75C21.44 20.5 22 21.06 22 21.75V22C22 22.1326 21.9473 22.2598 21.8536 22.3536C21.7598 22.4473 21.6326 22.5 21.5 22.5H10.5C10.3674 22.5 10.2402 22.4473 10.1464 22.3536C10.0527 22.2598 10 22.1326 10 22V21.75Z",
    fill: "#EE6F44"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBanks, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/banks.34f2d14b.svg";
export { ForwardRef as ReactComponent };